import PhoneFrame from "assets/images/phone_frame.png";
import LoadingPreview from "assets/animations/loading_preview.json";
import Lottie from "react-lottie";
import { Fragment, useState } from "react";
import { BoxMotion, CardMediaMotion } from "./material_motion";
import { Box, CardMedia } from "@mui/material";

export default function ProjectPhonePreview({url}) {
  const [loadingPreview, setLoadingPreview] = useState(true);

  return (
    <Fragment>
      <CardMediaMotion
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", delay: 0.0, duration: 1 }}
        component="img"
        src={PhoneFrame}
        sx={{
          position: "relative",
          top: 0,
          left: 0,
          right: 0,
          height: "auto",
          width: "auto",
          maxHeight: "100%",
          maxWidth: "100%",
        }}
      />
      <BoxMotion
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", delay: 0.0, duration: 1 }}
        sx={{
          aspectRatio: 1080 / 2167,
          position: "absolute",
          zIndex: -1,
          top: 40,
          bottom: 40,
          display: "flex",
        }}
      >
        <Box sx={{ flex: 0.91 }} />
        <Box sx={{ flex: 13.2, display: "flex", flexDirection: "column" }}>
          <Box sx={{ flex: 1.9 }} />
          <Box
            sx={{
              flex: 19,
              backgroundColor: "white",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ height: "6%" }} />
            <Box sx={{ flex: 1, position: "relative" }}>
              <CardMedia
                component="video"
                controls={false}
                autoPlay
                muted
                loop
                src={url}
                onCanPlayThrough={() => setLoadingPreview(false)}
                sx={{
                  width: "100%",
                  height: "auto",
                  transform: "scale(1.25)",
                }}
              />
              <BoxMotion
                variants={{
                  show: { opacity: 1 },
                  hide: { opacity: 0 },
                }}
                animate={loadingPreview ? "show" : "hide"}
                transition={{ type: "spring", delay: 0, duration: 1 }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  paddingBottom: 5,
                }}
              >
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: LoadingPreview,
                  }}
                  width={"80%"}
                />
              </BoxMotion>
            </Box>
          </Box>
          <Box sx={{ flex: 0.6 }} />
        </Box>
        <Box sx={{ flex: 1 }} />
      </BoxMotion>
    </Fragment>
  );
}
